'use strict';

function parse(reader) {
    reader.readUInt8("version");
    let count = (reader.getLength() - 5) / 67;
    for (let i = 1; i <= count; i++) {
        reader.readString(64, `data.ip_${i}.ip/domain`);
        reader.readUInt16LE(`data.ip_${i}.port`);
        reader.readUInt8(`data.ip_${i}.connected`, value => value === 1);
    }
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/uart/dtu-report-parser.js